import { useEffect, useState } from 'react'
import { useCameraStore } from './useCamera'

/**
 * 站点首次访问时显示一个轻量的"是否启用摄像头"对话框。
 * 拒绝时不阻断访问，整个站点仍可用（键鼠路径）。
 */
export function PermissionGate() {
  const status = useCameraStore((s) => s.status)
  const request = useCameraStore((s) => s.request)
  const decline = useCameraStore((s) => s.decline)
  const errorMessage = useCameraStore((s) => s.errorMessage)
  const [dismissed, setDismissed] = useState(false)

  // 自动收起的状态
  useEffect(() => {
    if (status === 'granted') {
      const t = setTimeout(() => setDismissed(true), 800)
      return () => clearTimeout(t)
    }
  }, [status])

  // 用户主动选择键鼠模式 → 静默关闭
  if (status === 'declined') return null
  if (dismissed && status === 'granted') return null
  if (status === 'granted') {
    return (
      <div className="permission-gate is-success" role="status">
        <span>摄像头已就绪 · 你可以开始浏览</span>
      </div>
    )
  }
  if (status === 'idle' || status === 'requesting') {
    return (
      <div className="permission-gate" role="dialog">
        <h2>欢迎来到 BNGU</h2>
        <p>
          这是一个用 <em>头部姿态</em> 与 <em>手势</em> 驱动的 3D 阅览站点。
          授权摄像头可以获得完整体验；拒绝也可继续使用键盘与鼠标。
        </p>
        <ul>
          <li>摄像头画面不上屏，不上传，仅在本地内存中处理。</li>
          <li>用 <kbd>C</kbd> 重新校准头部姿态；用 <kbd>Esc</kbd> 释放抓取。</li>
        </ul>
        <div className="permission-gate__actions">
          <button onClick={request} disabled={status === 'requesting'}>
            {status === 'requesting' ? '请求中…' : '启用摄像头'}
          </button>
          <button className="ghost" onClick={decline}>
            启用键盘和鼠标
          </button>
        </div>
      </div>
    )
  }
  if (status === 'denied' || status === 'unsupported' || status === 'error') {
    return (
      <div className="permission-gate is-warning" role="alert">
        <h2>未启用摄像头</h2>
        <p>{errorMessage ?? '已切换到键鼠模式。'}</p>
        <p className="hint">
          切换激活侧：<kbd>←</kbd> / <kbd>→</kbd> &nbsp; 翻页：<kbd>PgUp</kbd> / <kbd>PgDn</kbd> 或滚轮
        </p>
        <div className="permission-gate__actions">
          <button onClick={request}>重试</button>
          <button className="ghost" onClick={() => setDismissed(true)}>
            知道了
          </button>
        </div>
      </div>
    )
  }
  return null
}
